import axios from 'axios';
import apiRequestHeaders from '../apiRequestHeaders';
import { AuditLogsFilter } from '../../features/auditLogs/auditLogsSlice';

export function fetchAuditLogs(auditLogsFilter: AuditLogsFilter) {
  const bffConfig = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: auditLogsFilter,
  };

  return axios
    .get('/history/historylogs/getallhistorylogs', bffConfig)
    .then(res => res.data);
  // .catch(error => {
  //  console.log('error', error.toJSON());
  //  throw error;
  // });
  /*
  const mockAuditLogs = [{
          "id": "753bcfcf-45ee-4169-9f94-26ea377aa091",
          "data": "{\"Id\":\"a545bec2-1c31-4a9f-95ff-00f27ae154d5\",\"Name\":\"uusi tenantti 4\",\"Timestamp\":\"2022-01-03T13:36:34.6333207+00:00\",\"EventDescription\":null,\"MessageType\":\"TenantCreatedEvent\",\"AggregateId\":\"a545bec2-1c31-4a9f-95ff-00f27ae154d5\"}",
          "oldValues": "{\"Tenant\":null}",
          "newValues": "{\"Tenant\":\"{\\u0022Id\\u0022:\\u0022a545bec2-1c31-4a9f-95ff-00f27ae154d5\\u0022,\\u0022Name\\u0022:\\u0022uusi tenantti 4\\u0022}\"}",
          "userId": "00000000-0000-0000-0000-000000000000",
          "timestamp": "2022-01-03T13:36:35.1340321",
          "eventDescription": null,
          "messageType": "TenantCreatedEvent",
          "aggregateId": "a545bec2-1c31-4a9f-95ff-00f27ae154d5"
      },
      {
          "id": "305e5268-d805-493d-ac2e-6aff035d0f5e",
          "data": "{\"Id\":\"65fbd31e-4277-4cbb-9665-6d0391e33141\",\"Name\":\"uusi tenant 5\",\"Timestamp\":\"2022-01-03T09:27:40.4421545+00:00\",\"EventDescription\":null,\"MessageType\":\"TenantCreatedEvent\",\"AggregateId\":\"65fbd31e-4277-4cbb-9665-6d0391e33141\"}",
          "oldValues": "{\"Tenant\":null}",
          "newValues": "{\"Tenant\":\"{\\u0022Id\\u0022:\\u002265fbd31e-4277-4cbb-9665-6d0391e33141\\u0022,\\u0022Name\\u0022:\\u0022uusi tenant 5\\u0022}\"}",
          "userId": "00000000-0000-0000-0000-000000000000",
          "timestamp": "2022-01-03T09:27:40.9754914",
          "eventDescription": null,
          "messageType": "TenantCreatedEvent",
          "aggregateId": "65fbd31e-4277-4cbb-9665-6d0391e33141"
      },
      {
          "id": "bf7a5d26-cc3f-42b5-8965-422855484dd3",
          "data": "{\"Id\":\"069c9416-2b53-4a0f-881a-252354f233a2\",\"Name\":\"uusi tenant 4\",\"Timestamp\":\"2022-01-03T09:16:19.9480875+00:00\",\"EventDescription\":null,\"MessageType\":\"TenantCreatedEvent\",\"AggregateId\":\"069c9416-2b53-4a0f-881a-252354f233a2\"}",
          "oldValues": "{\"Tenant\":null}",
          "newValues": "{\"Tenant\":\"{\\u0022Id\\u0022:\\u0022069c9416-2b53-4a0f-881a-252354f233a2\\u0022,\\u0022Name\\u0022:\\u0022uusi tenant 4\\u0022}\"}",
          "userId": "00000000-0000-0000-0000-000000000000",
          "timestamp": "2022-01-03T09:16:20.0371463",
          "eventDescription": null,
          "messageType": "TenantCreatedEvent",
          "aggregateId": "069c9416-2b53-4a0f-881a-252354f233a2"
      }];

  return new Promise<{ data: any }>((resolve) =>
      setTimeout(() => resolve({ data: mockAuditLogs }), 1500)
  ); */
}
